import { useContext } from 'react';

import { DraggableConditions } from '../Conditions';
import { Logos } from '@/app/_components/shared/Logos/Logos';
import { SectionHeader } from '@swordhealth/ui-corporate';
import { Container } from '@/components/ui/flexbox';
import { StyledSection, StyledContainer } from './styles';

import ClientContext from '@/contexts/client.context';
import EligibilityClaim from '../EligibilityClaim/EligibilityClaim';
import Form from '../Form';

export default function Header({
  logos,
  content,
  showSwordLogo,
  hideEligibilityClaim = true,
  eligibilityClaim,
}) {
  const { client } = useContext(ClientContext);

  return (
    <StyledSection colored lastColored>
      <StyledContainer>
        <Logos logos={logos} showSwordLogo={showSwordLogo || !logos} />
        <SectionHeader
          title={content.title}
          description={content.subtitle}
          titleSize="3xl"
          xAlign="left"
          titleSeoLevel="h1"
        />
        {!hideEligibilityClaim && content.eligibilityClaim && (
          <EligibilityClaim>{content.eligibilityClaim}</EligibilityClaim>
        )}
        {!client?.clientKey && <Form client={client} product={client?.product} />}
      </StyledContainer>
      <DraggableConditions conditions={content?.conditions?.data} sectionName="Header" />
      <Container>
        {eligibilityClaim && <EligibilityClaim centered>{eligibilityClaim}</EligibilityClaim>}
      </Container>
    </StyledSection>
  );
}
